export default __webpack_public_path__ + "static/media/Flexa ausmessen frontal.44aaf212.jpg";